import React from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import DefaultSelectInput from "components/SelectInput/SelectInput";
import { Labels } from "utils/Labels";
import Table from "components/Table/Table";
import TextInput from "components/Input/TextInput";
import { onlyNumber } from "utils/rejex";

interface Props {
  searchDataGot: boolean;
  searchData: any;
  priceRange: any;
  propertySize: any;
  bedData: any;
  bathData: any;
  setSearchQueryAdvisorfunc: (id: string) => void;
  setSearchQueryStatusfunc: (id: string) => void;
  setSearchQueryRegionfunc: (id: string) => void;
  setSearchQueryPropertyTypefunc: (id: string) => void;
  setSearchQueryPropertySizefunc: (id: string) => void;
  setSearchQueryPriceRangefunc: (id: string) => void;
  setSearchQueryBedsfunc: (id: string) => void;
  setSearchQueryBathsfunc: (id: string) => void;
  setSearchQueryFurnishfunc: (id: string) => void;
  submitSearchQuery: () => void;
  ownerNameQuery: string;
  setOwnerNameQuery: React.Dispatch<React.SetStateAction<string>>;
  ownerMobileQuery: string;
  setOwnerMobileQuery: React.Dispatch<React.SetStateAction<string>>;
  depositeStatus: any;
  depositeStatusGot: boolean;
  tableContent: any;
  tableContentGot: boolean;
  searchQueryDepositeCode: string;
  handleChangeCodeInput: () => void;
  searchByDepositeCode: () => void;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
}

const PropertyListPage: React.FC<Props> = ({
  searchDataGot,
  searchData,
  priceRange,
  propertySize,
  bedData,
  bathData,
  setSearchQueryAdvisorfunc,
  setSearchQueryStatusfunc,
  setSearchQueryRegionfunc,
  setSearchQueryPropertyTypefunc,
  setSearchQueryPropertySizefunc,
  setSearchQueryPriceRangefunc,
  setSearchQueryBedsfunc,
  setSearchQueryBathsfunc,
  setSearchQueryFurnishfunc,
  submitSearchQuery,
  ownerNameQuery,
  setOwnerNameQuery,
  ownerMobileQuery,
  setOwnerMobileQuery,
  depositeStatus,
  depositeStatusGot,
  tableContent,
  tableContentGot,
  searchQueryDepositeCode,
  handleChangeCodeInput,
  searchByDepositeCode,
  setPageNumber,
}) => {
  const SiteText = SiteTexts();

  const TableHeader = [
    "Code",
    "Location",
    "Advisor",
    "Type",
    "Size",
    "Peyment",
    "Date",
    "View",
    "Image",
    "Action",
  ];

  return (
    <div className="property-list-main-parent">
      <div className="search-box-parent">
        <h4>{SiteText.PROPERTY_LIST.REFINE_YOUR_SEARCH}</h4>
        <div className="search-box-content-parent">
          {searchDataGot ? (
            <form onSubmit={submitSearchQuery}>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.Advisor}
                  list={searchData.listAdvisor}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-Advisor"}
                  onChangeValue={setSearchQueryAdvisorfunc}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.Status}
                  list={searchData.listStatus}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-Status"}
                  onChangeValue={setSearchQueryStatusfunc}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.Region}
                  list={searchData.listRegion}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-Region"}
                  onChangeValue={setSearchQueryRegionfunc}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.PropertyType}
                  list={searchData.listPropertys}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-PropertyType"}
                  onChangeValue={setSearchQueryPropertyTypefunc}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.PropertySize}
                  list={propertySize}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-PropertySize"}
                  onChangeValue={setSearchQueryPropertySizefunc}
                  disabled={propertySize.length > 0 ? false : true}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.PriceRange}
                  list={priceRange}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-PriceRange"}
                  onChangeValue={setSearchQueryPriceRangefunc}
                  disabled={priceRange.length > 0 ? false : true}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.Beds}
                  list={bedData}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-Beds"}
                  onChangeValue={setSearchQueryBedsfunc}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.Baths}
                  list={bathData}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-Baths"}
                  onChangeValue={setSearchQueryBathsfunc}
                  hasEmptyOption={true}
                />
              </div>
              <div className="select-input-parent">
                <DefaultSelectInput
                  lable={Labels.InputLabels.Furnish}
                  list={searchData.listDecorat}
                  className={"general-select-input"}
                  error={""}
                  required={false}
                  name={"select-input-Furnish"}
                  onChangeValue={setSearchQueryFurnishfunc}
                  hasEmptyOption={true}
                />
              </div>
              <div className="text-input-parent">
                <TextInput
                  lable={Labels.InputLabels.Name}
                  className={"general-select-input"}
                  error={""}
                  value={ownerNameQuery}
                  required={false}
                  name={"inpute-name"}
                  onChangeValue={setOwnerNameQuery}
                  autoFocus={false}
                  regex={""}
                  type={"text"}
                  removeLable={false}
                />
              </div>
              <div className="text-input-parent">
                <TextInput
                  lable={Labels.InputLabels.Mobile}
                  className={"general-select-input"}
                  error={""}
                  value={ownerMobileQuery}
                  required={false}
                  name={"inpute-mobile"}
                  onChangeValue={setOwnerMobileQuery}
                  autoFocus={false}
                  regex={onlyNumber}
                  type={"tel"}
                  removeLable={false}
                />
              </div>
              <div style={{width:'31%'}}></div>
              <div className="submit-search-input-parent">
                <button onSubmit={submitSearchQuery}>
                  {Labels.ButtonLabels.SEARCH}
                </button>
              </div>
            </form>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="table-main-parent-content">
        <div className="status-parent">
          {depositeStatusGot ? (
            <>
              <p>
                Unapproved Property <span>{depositeStatus.unApproved}</span>
                Result
              </p>
              <p>
                Approved Property <span>{depositeStatus.approved}</span> Result
              </p>
              <p>
                Archived Property <span>{depositeStatus.archived}</span> Result
              </p>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="property-list-table-parent">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h4>{SiteText.PROPERTY_LIST.LIST_PROPERTIES}</h4>
            <div>
              <form
                onSubmit={searchByDepositeCode}
                className="search-by-code-form"
              >
                <input
                  type={"number"}
                  value={searchQueryDepositeCode}
                  onChange={handleChangeCodeInput}
                  placeholder="Search by code"
                />
                <button onSubmit={searchByDepositeCode}>
                  {Labels.ButtonLabels.SEARCH}
                </button>
              </form>
            </div>
          </div>
          {tableContentGot ? (
            <Table
              TableHeader={TableHeader}
              TableContent={tableContent.data}
              TableContentName={"propertyList"}
              HeaderMinWidth={[
                "50px",
                "110px",
                "80px",
                "80px",
                "70px",
                "60px",
                "80px",
                "50px",
                "50px",
                "50px",
              ]}
              currentPage={tableContent.page}
              totalPage={Math.ceil(tableContent.total / tableContent.size)}
              setPageNumber={setPageNumber}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyListPage;
